import * as AgGrid from "ag-grid-community";
import * as dom from "../../utils/dom";
import * as gridUtils from "../../grid/utils";

export enum Action {
  REQUEST_REFUND = "request_refund",
  EDIT = "edit",
  ACCEPT = "accept",
  REJECT = "reject",
}

interface Data {
  status: String;
}

export function onActionCellClicked(params: AgGrid.CellClickedEvent, handler: (action: Action) => void) {
  const $target = params.event.target as HTMLElement;
  if (!$target) {
    return;
  }
  const $button = $target.tagName.toLowerCase() == "button" ? $target : $target.closest("button");

  if ($button) {
    handler($button.dataset["action"] as Action);
  }
}

const EDIT_ACTIONS = [Action.ACCEPT, Action.REJECT];

const show = (data: Data, $agCell: HTMLElement) =>
  $agCell && transformRowActions($agCell, EDIT_ACTIONS, data, dom.showElement);

const hide = ($agCell: HTMLElement) =>
  $agCell && $agCell.querySelectorAll<HTMLButtonElement>("button").forEach(dom.hideElement);

function transformRowActions(
  $agCell: HTMLElement,
  actions: Action[],
  data: Data,
  transformFn: (el: HTMLButtonElement) => void,
): void {
  actions.forEach((action) =>
    $agCell.querySelectorAll<HTMLButtonElement>(`button[data-action="${action}"]`).forEach(transformFn),
  );
}

export const GRID_CALLBACKS: AgGrid.GridOptions = {
  onCellMouseOver(params) {
    show(params.data, gridUtils.actionsCell(params));
  },
  onCellMouseOut(params) {
    hide(gridUtils.actionsCell(params));
  },
};
